import Vue from "vue";
import Router from "vue-router";
import routerConfig from "@/config/routes";
import VueMeta from 'vue-meta'
import {remoteEmit} from "@/utils/remoteExpose";
Vue.use(VueMeta)
Vue.use(Router);


Vue.use(Router);

const router = new Router({
  base: '/',
  mode: 'history',
  routes: routerConfig
});


// 自动加token
router.beforeEach((to, from, next) => {

  remoteEmit("vueRouterChange", JSON.stringify({
    to: {
      fullPath:to.fullPath,
      hash:to.hash,
      href:to.href,
      meta:to.meta,
      name:to.name,
      params:to.params,
      path:to.path,
      query:to.query
    },
    from: {
      fullPath:from.fullPath,
      hash:from.hash,
      href:from.href,
      meta:from.meta,
      name:from.name,
      params:from.params,
      path:to.path,
      query:to.query
    }
  }))

  if (to.query && to.query.token) sessionStorage.setItem('token', to.query.token)
  if (to.query && to.query.desensitizationStatus) sessionStorage.setItem('desensitizationStatus', to.query.desensitizationStatus)
  if (from.query.token != null && to.query.token == null) {
    const updatedNext = {
      ...to,
      query: {
        // This line is used to retain other query if there is any
        ...to.query,
        token: from.query.token,
      },
    };
    //console.log(updatedNext)
    router.push(updatedNext)
    //next(updatedNext);
    return
  } else {
    next();
  }


});



export default router;
